(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premium-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const create = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };

    const initHomepage = (root) => {
      if (!root || initialized.has(root)) return;
      initialized.add(root);

      const configElement = root.querySelector('[data-vip-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const messages = config.messages;
      const rootUrl = root.dataset.rootUrl.endsWith('/') ? root.dataset.rootUrl : `${root.dataset.rootUrl}/`;
      const currency = root.dataset.currency || 'USD';
      const productCache = new Map();
      const productData = new Map();
      let lastFocusedElement = null;

      const formatMoney = (cents) => {
        const amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(2)}`;
        }
      };

      const normalizeImageUrl = (source, width) => {
        if (!source) return '';
        const absoluteSource = source.startsWith('//') ? `https:${source}` : source;
        try {
          const imageUrl = new URL(absoluteSource, window.location.origin);
          imageUrl.searchParams.set('width', String(width));
          return imageUrl.toString();
        } catch (error) {
          return absoluteSource;
        }
      };

      const setProductImage = (image, source, alt, size, sizes) => {
        if (!source) {
          image.hidden = true;
          return;
        }
        image.hidden = false;
        image.src = normalizeImageUrl(source, size);
        image.srcset = [180, 360, 540, 720]
          .filter((width) => width <= size)
          .map((width) => `${normalizeImageUrl(source, width)} ${width}w`)
          .join(', ');
        image.sizes = sizes;
        image.width = size;
        image.height = size;
        image.loading = 'lazy';
        image.alt = alt || '';
      };

      const productUrl = (handle) => `${rootUrl}products/${encodeURIComponent(handle)}`;

      const getProduct = (handle) => {
        if (productCache.has(handle)) return productCache.get(handle);
        const request = fetch(`${productUrl(handle)}.js`, {
          headers: { Accept: 'application/json' }
        })
          .then((response) => {
            if (!response.ok) throw new Error(messages.loadError);
            return response.json();
          })
          .then((product) => {
            productData.set(handle, product);
            return product;
          })
          .catch((error) => {
            productCache.delete(handle);
            throw error;
          });
        productCache.set(handle, request);
        return request;
      };

      const firstVariant = (product) => product.variants.find((variant) => variant.available) || product.variants[0] || null;

      const toastContainer = root.querySelector('[data-toast-container]');
      const showToast = (message) => {
        if (!toastContainer || !message) return;
        const toast = create('div', 'toast', message);
        toast.setAttribute('role', 'status');
        toastContainer.append(toast);
        window.setTimeout(() => toast.remove(), 4000);
      };

      const header = root.querySelector('[data-vip-header]');
      const updateHeader = () => header?.classList.toggle('scrolled', window.scrollY > 40);
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const dotsContainer = root.querySelector('[data-slide-dots]');
      let currentSlide = 0;
      let slideTimer = null;

      const showSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === currentSlide;
          slide.classList.toggle('active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dotsContainer?.querySelectorAll('button').forEach((dot, dotIndex) => {
          dot.classList.toggle('active', dotIndex === currentSlide);
          dot.setAttribute('aria-current', dotIndex === currentSlide ? 'true' : 'false');
        });
      };

      if (dotsContainer && slides.length > 1) {
        slides.forEach((slide, index) => {
          const dot = create('button', 'hero-nav-dot');
          dot.type = 'button';
          dot.setAttribute('aria-label', `${index + 1}`);
          dot.addEventListener('click', () => showSlide(index));
          dotsContainer.append(dot);
        });
        showSlide(0);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          slideTimer = window.setInterval(() => showSlide(currentSlide + 1), 6500);
          root.querySelector('[data-slideshow]')?.addEventListener('focusin', () => window.clearInterval(slideTimer), { once: true });
        }
      }

      const mobileToggle = root.querySelector('[data-mobile-toggle]');
      const nav = root.querySelector('[data-vip-nav]');
      const cartDrawer = root.querySelector('[data-cart-drawer]');

      const syncBodyLock = () => {
        const locked = nav?.classList.contains('active') || cartDrawer?.classList.contains('active');
        document.body.classList.toggle('vip-scroll-locked', Boolean(locked));
      };

      const closeMenu = () => {
        nav?.classList.remove('active');
        mobileToggle?.setAttribute('aria-expanded', 'false');
        syncBodyLock();
      };

      mobileToggle?.addEventListener('click', () => {
        const open = !nav?.classList.contains('active');
        nav?.classList.toggle('active', open);
        mobileToggle.setAttribute('aria-expanded', String(open));
        syncBodyLock();
      });

      nav?.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeMenu();
      });

      const productsGrid = root.querySelector('[data-products-grid]');
      const productsStatus = root.querySelector('[data-products-status]');
      const productsPanel = root.querySelector('[data-products-panel]');
      const tabs = Array.from(root.querySelectorAll('[data-collection]'));
      const viewAll = root.querySelector('[data-view-all]');
      let renderVersion = 0;

      const priceBlock = (product, variant) => {
        const wrapper = create('div', 'product-card-price');
        wrapper.append(create('span', '', formatMoney(variant?.price || product.price)));
        const comparePrice = Number(variant?.compare_at_price || product.compare_at_price || 0);
        const currentPrice = Number(variant?.price || product.price || 0);
        if (comparePrice > currentPrice) {
          const compare = create('del', '', formatMoney(comparePrice));
          wrapper.append(compare);
        }
        return wrapper;
      };

      const createProductCard = (product, handle) => {
        const variant = firstVariant(product);
        const url = productUrl(product.handle || handle);
        const card = create('article', 'product-card');
        card.dataset.productHandle = product.handle || handle;
        if (variant) card.dataset.variantId = String(variant.id);

        const imageLink = create('a', 'product-card-img-link');
        imageLink.href = url;
        imageLink.setAttribute('aria-label', product.title);
        const image = create('img');
        setProductImage(image, product.featured_image || product.images?.[0], product.title, 720, '(max-width: 767px) 92vw, (max-width: 1120px) 46vw, 23vw');
        imageLink.append(image);

        const info = create('div', 'product-card-info');
        info.append(create('span', 'product-card-vendor', product.vendor || ''));
        const title = create('a', 'product-card-title', product.title);
        title.href = url;
        info.append(title);
        info.append(create('span', 'product-card-handle', `${messages.handle}: ${product.handle || handle}`));

        const footer = create('div', 'product-card-footer');
        footer.append(priceBlock(product, variant));
        const availability = create('span', 'product-card-availability', product.available ? messages.available : messages.soldOut);
        availability.classList.toggle('sold-out', !product.available);
        footer.append(availability);
        info.append(footer);

        const actions = create('div', 'product-card-actions');
        const quickAdd = create('button', 'quick-add-btn');
        quickAdd.type = 'button';
        quickAdd.dataset.quickAdd = product.handle || handle;
        const hasMultipleVariants = product.variants.length > 1;
        quickAdd.textContent = hasMultipleVariants ? messages.chooseOptions : product.available ? messages.addToCart : messages.soldOut;
        quickAdd.disabled = !product.available;
        const details = create('a', 'view-details-link', messages.viewDetails);
        details.href = url;
        actions.append(quickAdd, details);
        info.append(actions);
        card.append(imageLink, info);
        return card;
      };

      const updateViewAll = (group) => {
        if (!viewAll) return;
        const search = new URL(root.dataset.searchUrl, window.location.origin);
        search.searchParams.set('type', 'product');
        search.searchParams.set('q', config.queries[group] || '');
        viewAll.href = `${search.pathname}${search.search}`;
      };

      const renderProducts = async (group) => {
        const version = ++renderVersion;
        const handles = config.groups[group] || [];
        productsGrid?.replaceChildren();
        if (productsStatus) productsStatus.textContent = messages.loading;
        updateViewAll(group);

        if (!handles.length) {
          if (productsStatus) productsStatus.textContent = messages.noProducts;
          return;
        }

        const results = await Promise.allSettled(handles.map((handle) => getProduct(handle)));
        if (version !== renderVersion || !productsGrid) return;

        let displayed = 0;
        results.forEach((result, index) => {
          if (result.status !== 'fulfilled') return;
          productsGrid.append(createProductCard(result.value, handles[index]));
          displayed += 1;
        });
        if (productsStatus) {
          productsStatus.textContent = displayed === 0 ? messages.loadError : displayed < handles.length ? messages.loadError : '';
        }
      };

      const selectTab = (tab, shouldFocus = false) => {
        if (!tab) return;
        tabs.forEach((candidate) => {
          const active = candidate === tab;
          candidate.classList.toggle('active', active);
          candidate.setAttribute('aria-selected', String(active));
          candidate.tabIndex = active ? 0 : -1;
        });
        if (productsPanel) productsPanel.setAttribute('aria-labelledby', tab.id);
        if (shouldFocus) tab.focus();
        renderProducts(tab.dataset.collection);
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let targetIndex = index;
          if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = tabs.length - 1;
          selectTab(tabs[targetIndex], true);
        });
      });

      root.querySelectorAll('[data-collection-target]').forEach((card) => {
        card.addEventListener('click', () => {
          const tab = tabs.find((candidate) => candidate.dataset.collection === card.dataset.collectionTarget);
          selectTab(tab);
          root.querySelector('#popular-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      root.querySelector('[data-hero-pallet-link]')?.addEventListener('click', () => {
        selectTab(tabs.find((tab) => tab.dataset.collection === 'pallet-quantities'));
      });

      const addToCart = async (variantId, quantity, button) => {
        if (!variantId || !Number.isInteger(quantity) || quantity < 1) throw new Error(messages.cartError);
        const originalText = button?.textContent;
        if (button) {
          button.disabled = true;
          button.textContent = messages.adding;
        }
        try {
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity })
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.description || result.message || messages.cartError);
          await loadCart();
          showToast(messages.added);
          openCart();
          return result;
        } finally {
          if (button) {
            button.disabled = false;
            button.textContent = originalText;
          }
        }
      };

      productsGrid?.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-quick-add]');
        if (!button) return;
        const handle = button.dataset.quickAdd;
        const product = productData.get(handle);
        if (!product) return;
        if (product.variants.length > 1) {
          window.location.assign(productUrl(handle));
          return;
        }
        const variant = firstVariant(product);
        if (!variant?.available) {
          showToast(messages.soldOut);
          return;
        }
        try {
          await addToCart(variant.id, 1, button);
        } catch (error) {
          showToast(error.message || messages.cartError);
        }
      });

      const featuredImage = root.querySelector('[data-featured-image]');
      const featuredImageLink = root.querySelector('[data-featured-image-link]');
      const featuredTitleLink = root.querySelector('[data-featured-title-link]');
      const featuredVendor = root.querySelector('[data-featured-vendor]');
      const featuredPrice = root.querySelector('[data-featured-price]');
      const featuredCompare = root.querySelector('[data-featured-compare]');
      const featuredAvailability = root.querySelector('[data-featured-availability]');
      const featuredProductLink = root.querySelector('[data-featured-product-link]');
      const featuredAdd = root.querySelector('[data-featured-add]');
      const featuredQuantity = root.querySelector('[data-featured-quantity]');
      const featuredOptions = Array.from(root.querySelectorAll('[data-featured-handle]'));
      let featuredProduct = null;
      let featuredVersion = 0;

      const updateFeatured = async (handle) => {
        const version = ++featuredVersion;
        if (featuredAvailability) {
          featuredAvailability.textContent = messages.loading;
          featuredAvailability.classList.remove('sold-out');
        }
        if (featuredAdd) featuredAdd.disabled = true;
        try {
          const product = await getProduct(handle);
          if (version !== featuredVersion) return;
          featuredProduct = product;
          const variant = firstVariant(product);
          const url = productUrl(product.handle || handle);
          if (featuredImage) setProductImage(featuredImage, product.featured_image || product.images?.[0], product.title, 900, '(max-width: 767px) 92vw, 50vw');
          if (featuredImageLink) featuredImageLink.href = url;
          if (featuredTitleLink) {
            featuredTitleLink.href = url;
            featuredTitleLink.textContent = product.title;
          }
          if (featuredProductLink) featuredProductLink.href = url;
          if (featuredVendor) featuredVendor.textContent = product.vendor || '';
          if (featuredPrice) featuredPrice.textContent = formatMoney(variant?.price || product.price);
          const comparePrice = Number(variant?.compare_at_price || product.compare_at_price || 0);
          const currentPrice = Number(variant?.price || product.price || 0);
          if (featuredCompare) {
            featuredCompare.hidden = comparePrice <= currentPrice;
            featuredCompare.textContent = comparePrice > currentPrice ? formatMoney(comparePrice) : '';
          }
          if (featuredAvailability) {
            featuredAvailability.textContent = product.available ? messages.available : messages.soldOut;
            featuredAvailability.classList.toggle('sold-out', !product.available);
          }
          if (featuredAdd) {
            featuredAdd.disabled = !product.available;
            featuredAdd.textContent = product.variants.length > 1 ? messages.chooseOptions : product.available ? messages.addToCart : messages.soldOut;
          }
        } catch (error) {
          featuredProduct = null;
          if (featuredAvailability) {
            featuredAvailability.textContent = messages.loadError;
            featuredAvailability.classList.add('sold-out');
          }
          if (featuredAdd) {
            featuredAdd.disabled = true;
            featuredAdd.textContent = messages.loadError;
          }
        }
      };

      featuredOptions.forEach((option) => {
        option.addEventListener('click', () => {
          featuredOptions.forEach((candidate) => {
            const active = candidate === option;
            candidate.classList.toggle('active', active);
            candidate.setAttribute('aria-pressed', String(active));
          });
          updateFeatured(option.dataset.featuredHandle);
        });
      });

      root.querySelector('[data-featured-minus]')?.addEventListener('click', () => {
        if (!featuredQuantity) return;
        featuredQuantity.value = String(Math.max(1, Number.parseInt(featuredQuantity.value, 10) - 1 || 1));
      });

      root.querySelector('[data-featured-plus]')?.addEventListener('click', () => {
        if (!featuredQuantity) return;
        featuredQuantity.value = String(Math.max(1, Number.parseInt(featuredQuantity.value, 10) + 1 || 1));
      });

      featuredAdd?.addEventListener('click', async () => {
        if (!featuredProduct) return;
        if (featuredProduct.variants.length > 1) {
          window.location.assign(productUrl(featuredProduct.handle));
          return;
        }
        const variant = firstVariant(featuredProduct);
        const quantity = Math.max(1, Number.parseInt(featuredQuantity?.value || '1', 10) || 1);
        if (!variant?.available) {
          showToast(messages.soldOut);
          return;
        }
        try {
          await addToCart(variant.id, quantity, featuredAdd);
        } catch (error) {
          showToast(error.message || messages.cartError);
        }
      });

      const cartToggle = root.querySelector('[data-cart-toggle]');
      const cartClose = root.querySelector('[data-cart-close]');
      const cartOverlay = root.querySelector('[data-cart-overlay]');
      const cartItems = root.querySelector('[data-cart-items]');
      const cartStatus = root.querySelector('[data-cart-status]');
      const cartCount = root.querySelector('[data-cart-count]');
      const cartSubtotal = root.querySelector('[data-cart-subtotal]');

      const openCart = () => {
        if (!cartDrawer || !cartOverlay) return;
        lastFocusedElement = document.activeElement;
        cartDrawer.classList.add('active');
        cartOverlay.classList.add('active');
        cartDrawer.setAttribute('aria-hidden', 'false');
        cartOverlay.tabIndex = 0;
        syncBodyLock();
        cartClose?.focus();
      };

      const closeCart = () => {
        if (!cartDrawer || !cartOverlay) return;
        cartDrawer.classList.remove('active');
        cartOverlay.classList.remove('active');
        cartDrawer.setAttribute('aria-hidden', 'true');
        cartOverlay.tabIndex = -1;
        syncBodyLock();
        if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
      };

      const renderCart = (cart) => {
        if (!cartItems) return;
        cartItems.replaceChildren();
        if (cartCount) cartCount.textContent = String(cart.item_count || 0);
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price || 0);
        if (!cart.items?.length) {
          cartItems.append(create('p', 'cart-empty', messages.cartEmpty));
          return;
        }

        cart.items.forEach((item) => {
          const row = create('article', 'cart-item');
          const imageLink = create('a');
          imageLink.href = item.url;
          const image = create('img', 'cart-item-img');
          setProductImage(image, item.image, item.product_title, 180, '78px');
          imageLink.append(image);

          const details = create('div', 'cart-item-details');
          const title = create('a', 'cart-item-title', item.product_title);
          title.href = item.url;
          details.append(title);
          if (item.variant_title && item.variant_title !== 'Default Title') details.append(create('div', 'cart-item-variant', item.variant_title));
          details.append(create('div', 'cart-item-price', formatMoney(item.final_line_price)));

          const actions = create('div', 'cart-item-actions');
          const quantity = create('div', 'cart-item-qty');
          const minus = create('button', 'cart-qty-btn', '−');
          minus.type = 'button';
          minus.dataset.cartKey = item.key;
          minus.dataset.cartQuantity = String(Math.max(0, item.quantity - 1));
          minus.setAttribute('aria-label', messages.decrease);
          const value = create('span', 'cart-qty-val', String(item.quantity));
          const plus = create('button', 'cart-qty-btn', '+');
          plus.type = 'button';
          plus.dataset.cartKey = item.key;
          plus.dataset.cartQuantity = String(item.quantity + 1);
          plus.setAttribute('aria-label', messages.increase);
          quantity.append(minus, value, plus);
          const remove = create('button', 'cart-item-remove-btn', messages.remove);
          remove.type = 'button';
          remove.dataset.cartKey = item.key;
          remove.dataset.cartQuantity = '0';
          actions.append(quantity, remove);
          details.append(actions);
          row.append(imageLink, details);
          cartItems.append(row);
        });
      };

      const loadCart = async () => {
        if (cartStatus) cartStatus.textContent = '';
        const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(cart.description || cart.message || messages.cartError);
        renderCart(cart);
        return cart;
      };

      const changeCart = async (key, quantity, button) => {
        button.disabled = true;
        if (cartStatus) cartStatus.textContent = messages.loading;
        try {
          const response = await fetch(`${rootUrl}cart/change.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: key, quantity })
          });
          const cart = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(cart.description || cart.message || messages.cartError);
          renderCart(cart);
          if (cartStatus) cartStatus.textContent = '';
        } catch (error) {
          if (cartStatus) cartStatus.textContent = error.message || messages.cartError;
        } finally {
          button.disabled = false;
        }
      };

      cartItems?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cart-key]');
        if (!button) return;
        changeCart(button.dataset.cartKey, Number.parseInt(button.dataset.cartQuantity, 10), button);
      });

      cartToggle?.addEventListener('click', async () => {
        try {
          await loadCart();
        } catch (error) {
          if (cartStatus) cartStatus.textContent = error.message || messages.cartError;
        }
        openCart();
      });
      cartClose?.addEventListener('click', closeCart);
      cartOverlay?.addEventListener('click', closeCart);

      const searchForm = root.querySelector('[data-search-form]');
      const searchInput = root.querySelector('[data-search-input]');
      const searchResults = root.querySelector('[data-search-results]');
      let searchTimer = null;
      let searchController = null;

      const closeSearch = () => {
        if (!searchResults || !searchInput) return;
        searchResults.hidden = true;
        searchInput.setAttribute('aria-expanded', 'false');
      };

      const showSearchMessage = (message) => {
        if (!searchResults || !searchInput) return;
        searchResults.replaceChildren(create('p', 'search-message', message));
        searchResults.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
      };

      const renderSearchResults = (products) => {
        if (!searchResults || !searchInput) return;
        searchResults.replaceChildren();
        if (!products.length) {
          showSearchMessage(messages.searchEmpty);
          return;
        }
        products.forEach((product) => {
          const item = create('a', 'search-result-item');
          item.href = product.url;
          item.setAttribute('role', 'option');
          const image = create('img');
          const source = product.featured_image?.url || product.image || '';
          setProductImage(image, source, product.featured_image?.alt || product.title, 120, '58px');
          const info = create('span');
          info.append(create('span', 'search-result-title', product.title));
          const priceInCents = Math.round(Number.parseFloat(product.price || '0') * 100);
          info.append(create('span', 'search-result-price', formatMoney(priceInCents)));
          item.append(image, info);
          searchResults.append(item);
        });
        searchResults.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
      };

      const searchProducts = async (query) => {
        searchController?.abort();
        searchController = new AbortController();
        showSearchMessage(messages.searchLoading);
        try {
          const endpoint = new URL(root.dataset.predictiveSearchUrl, window.location.origin);
          endpoint.searchParams.set('q', query);
          endpoint.searchParams.set('resources[type]', 'product');
          endpoint.searchParams.set('resources[limit]', '6');
          endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
          const response = await fetch(endpoint, {
            signal: searchController.signal,
            headers: { Accept: 'application/json' }
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(messages.searchError);
          renderSearchResults(result.resources?.results?.products || []);
        } catch (error) {
          if (error.name !== 'AbortError') showSearchMessage(messages.searchError);
        }
      };

      searchInput?.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        const query = searchInput.value.trim();
        if (query.length < 2) {
          closeSearch();
          return;
        }
        searchTimer = window.setTimeout(() => searchProducts(query), 250);
      });

      searchInput?.addEventListener('keydown', (event) => {
        const resultLinks = Array.from(searchResults?.querySelectorAll('a') || []);
        if (event.key === 'ArrowDown' && resultLinks.length) {
          event.preventDefault();
          resultLinks[0].focus();
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          closeSearch();
        }
      });

      searchResults?.addEventListener('keydown', (event) => {
        const resultLinks = Array.from(searchResults.querySelectorAll('a'));
        const index = resultLinks.indexOf(document.activeElement);
        if (event.key === 'ArrowDown' && index < resultLinks.length - 1) {
          event.preventDefault();
          resultLinks[index + 1].focus();
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (index <= 0) searchInput?.focus();
          else resultLinks[index - 1].focus();
        }
        if (event.key === 'Escape') {
          closeSearch();
          searchInput?.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (searchForm && !searchForm.contains(event.target)) closeSearch();
      });

      const calculatorForm = root.querySelector('[data-calculator-form]');
      const calculatorRefrigerant = root.querySelector('[data-calc-refrigerant]');
      const calculatorInput = root.querySelector('[data-calc-input]');
      const calculatorInputLabel = root.querySelector('[data-calc-input-label]');
      const calculatorResult = root.querySelector('[data-calc-result]');
      const calculatorResultLabel = root.querySelector('[data-calc-result-label]');
      const calculatorUnit = root.querySelector('[data-calc-unit]');
      const calculatorModes = Array.from(root.querySelectorAll('[data-calc-mode]'));
      let calculatorMode = 't-to-p';
      const coefficients = {
        R22: { a: 0.0101, b: 0.708, c: 24.0 },
        R410A: { a: 0.0157, b: 1.117, c: 48.6 },
        R134a: { a: 0.00776, b: 0.4022, c: 6.5 },
        R32: { a: 0.01566, b: 1.123, c: 51.0 },
        R404A: { a: 0.01267, b: 0.843, c: 33.0 }
      };

      calculatorModes.forEach((mode) => {
        mode.addEventListener('click', () => {
          calculatorMode = mode.dataset.calcMode;
          calculatorModes.forEach((candidate) => {
            const active = candidate === mode;
            candidate.classList.toggle('active', active);
            candidate.setAttribute('aria-pressed', String(active));
          });
          const tempToPressure = calculatorMode === 't-to-p';
          if (calculatorInputLabel) calculatorInputLabel.textContent = tempToPressure ? messages.inputTemp : messages.inputPressure;
          if (calculatorResultLabel) calculatorResultLabel.textContent = tempToPressure ? messages.saturatedPressure : messages.saturatedTemperature;
          if (calculatorUnit) calculatorUnit.textContent = tempToPressure ? 'psig' : '°F';
          if (calculatorResult) calculatorResult.textContent = '—';
          if (calculatorInput) calculatorInput.value = '';
        });
      });

      calculatorForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        const value = Number.parseFloat(calculatorInput?.value || '');
        const coefficient = coefficients[calculatorRefrigerant?.value];
        if (!Number.isFinite(value) || !coefficient || !calculatorResult) return;
        let result;
        if (calculatorMode === 't-to-p') {
          result = coefficient.a * value * value + coefficient.b * value + coefficient.c;
        } else {
          const discriminant = coefficient.b * coefficient.b - 4 * coefficient.a * (coefficient.c - value);
          result = discriminant < 0 ? Number.NaN : (-coefficient.b + Math.sqrt(discriminant)) / (2 * coefficient.a);
        }
        calculatorResult.textContent = Number.isFinite(result) ? result.toFixed(1) : messages.outOfRange;
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeSearch();
        closeMenu();
        if (cartDrawer?.classList.contains('active')) closeCart();
      });

      selectTab(tabs[0]);
      updateFeatured('r22-30-lbs-refrigerant');
      loadCart().catch(() => {
        if (cartStatus) cartStatus.textContent = messages.cartError;
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-vip-homepage]').forEach(initHomepage);
      if (scope.matches?.('[data-vip-homepage]')) initHomepage(scope);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-product"]) return;
  try {
    
  if (!customElements.get('vip-product')) {
    customElements.define('vip-product', class VipProduct extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variant-data]')?.textContent || '[]');
        this.form = this.querySelector('.vip-product__form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.optionInputs = Array.from(this.querySelectorAll('[data-option-input]'));
        this.price = this.querySelector('[data-price]');
        this.comparePrice = this.querySelector('[data-compare-price]');
        this.availability = this.querySelector('[data-availability]');
        this.skuNodes = this.querySelectorAll('[data-sku]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.submitButtons = this.querySelectorAll('.vip-product__add, .vip-product__sticky button');
        this.availabilityText = this.querySelector('[data-availability-text]');
        this.optionInputs.forEach((input) => input.addEventListener('change', () => this.onOptionChange()));
        this.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => this.setActiveMedia(button.dataset.mediaTarget)));
        this.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.quantityChange))));
        this.querySelector('[data-zoom-open]')?.addEventListener('click', () => this.openLightbox());
      }

      onOptionChange() {
        const values = Array.from(this.querySelectorAll('[data-option-position]')).map((group) => {
          const checked = group.querySelector('[data-option-input]:checked');
          group.querySelector('[data-selected-option]').textContent = checked?.value || '';
          return checked?.value;
        });
        const variant = this.variants.find((item) => item.options.every((value, index) => value === values[index]));
        if (variant) this.updateVariant(variant);
      }

      updateVariant(variant) {
        this.variantInput.value = variant.id;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.price.textContent = variant.price;
        this.stickyPrice.textContent = variant.price;
        this.comparePrice.textContent = variant.compareAtPrice;
        this.comparePrice.hidden = !(variant.compareAtPriceValue > variant.priceValue);
        this.skuNodes.forEach((node) => { node.textContent = variant.sku; });
        this.availability.classList.toggle('is-sold-out', !variant.available);
        this.availabilityText.textContent = variant.available ? this.dataset.inStock : this.dataset.soldOut;
        this.submitButtons.forEach((button) => {
          button.disabled = !variant.available;
          const text = button.querySelector('.btn-text > span') || button.querySelector('.btn-text');
          if (text) text.textContent = variant.available ? this.dataset.addToCart : this.dataset.soldOut;
        });
        if (variant.featuredMediaId) this.setActiveMedia(String(variant.featuredMediaId));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      setActiveMedia(mediaId) {
        this.querySelectorAll('[data-media-id]').forEach((media) => {
          const active = media.dataset.mediaId === String(mediaId);
          media.hidden = !active;
          media.classList.toggle('is-active', active);
        });
        this.querySelectorAll('[data-media-target]').forEach((button) => {
          const active = button.dataset.mediaTarget === String(mediaId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      changeQuantity(delta) {
        const input = this.querySelector('[data-quantity] input');
        if (!input) return;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      openLightbox() {
        const activeImage = this.querySelector('[data-media-id]:not([hidden]) img');
        const dialog = this.querySelector('[data-lightbox]');
        const lightboxImage = dialog?.querySelector('[data-lightbox-image]');
        if (!activeImage || !dialog || !lightboxImage) return;
        lightboxImage.src = activeImage.currentSrc || activeImage.src;
        lightboxImage.alt = activeImage.alt;
        if (typeof dialog.showModal === 'function') dialog.showModal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
